const STORAGE_KEY = 'gs_device_id_v1';

/** ID estável do dispositivo/navegador (anti-abuso no cadastro promocional). */
export function getOrCreateDeviceId() {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing && /^[a-zA-Z0-9_-]{8,128}$/.test(existing)) {
      return existing;
    }
    const id =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID().replace(/-/g, '')
        : `d${Date.now().toString(36)}${Math.random().toString(36).slice(2, 14)}`;
    localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    return null;
  }
}
